import React from 'react';

interface CustomToggleProps {
  onClick: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  variant: 'primary' | 'transparent' | 'rounded' | 'no-border';
  children?: React.ReactNode;
  toggleIcon?: React.ReactNode;
  fullwidth?: boolean;
}

export const CustomToggle = React.forwardRef<HTMLButtonElement, CustomToggleProps>(
  ({ children, onClick, toggleIcon, variant = 'primary', fullwidth = false }, ref) => (
    <button
      ref={ref}
      className={`new-dropdown__toggle new-dropdown__toggle--${variant}${fullwidth ? ' new-dropdown__toggle--fullwidth' : ''}`}
      onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();
        onClick(e);
      }}
    >
      {children && children}
      {toggleIcon ? toggleIcon : <i className="fa fa-chevron-down" />}
    </button>
  )
);
